import Headbar from '../components/Headbar';
import CategoryImages from '../components/Category/CategoryImages';

export default function Category() {
  return (
    <>
      <Headbar />
      <CategoryImages />
    </>
  );
}
